import { render, staticRenderFns } from "./ReservationColumnEdit.vue?vue&type=template&id=bc2568c8&scoped=true&"
import script from "./ReservationColumnEdit.vue?vue&type=script&lang=js&"
export * from "./ReservationColumnEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReservationColumnEdit.vue?vue&type=style&index=0&id=bc2568c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc2568c8",
  null
  
)

export default component.exports